module.exports = __webpack_public_path__ + "static/img/more-case.7e8d580.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/more-case.png
// module id = lWDc
// module chunks = 0